export default "__VITE_ASSET__PG6NHku$__"